import { GET_FILE_TYPE, GET_FILE_UPLOAD_LOGS, GET_RESE_CUSTOM_FILE_NAME, GET_RESE_CUSTOM_FILE_CONTENT } from "./actionTypes";

const initialState = {
    fileTypeList: [],
    fileTypeErrorMessage: null,
    fileUploadLogs: [],
    fileUploadLogsErrorMessage: null,
    reseCustomFileNameData: [],
    customFileContent:[],
};

const reseFileuploadReducer = (
    state = initialState,
    action = { type: "" }
) => {
    switch (action.type) {
        case GET_FILE_TYPE.SUCCESS:
            return {
                ...state,
                fileTypeList: [...action.payload],
                fileTypeErrorMessage: null,
            };
        case GET_FILE_TYPE.ERROR:
            return {
                ...state,
                fileTypeList: [],
                fileTypeErrorMessage: action.payload,
            };
        case GET_FILE_UPLOAD_LOGS.SUCCESS:
            return {
                ...state,
                fileUploadLogs: action.payload,
                fileUploadLogsErrorMessage: null,
            };
        case GET_FILE_UPLOAD_LOGS.ERROR:
            return {
                ...state,
                fileUploadLogs: [],
                fileUploadLogsErrorMessage: action.payload,
            };
        case GET_RESE_CUSTOM_FILE_NAME.SUCCESS:
            return {
                ...state,
                reseCustomFileNameData: [...action.payload],
                fileTypeErrorMessage: null,
            };
        case GET_RESE_CUSTOM_FILE_CONTENT.SUCCESS:
            return {
                ...state,
                customFileContent: action.payload,
            }
        default:
            return {
                ...state,
            };
    }
};

export default reseFileuploadReducer;
